import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireOttStreamMarker} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable({
  providedIn: 'root',
})
export class OttMarkersService implements CrudService<UmpireOttStreamMarker> {
  constructor(readonly http: TisaUmpireHttpService) {}

  create(
    body: Partial<UmpireOttStreamMarker>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttStreamMarker>> {
    return this.http
      .post(`/ott/markers`, serialize({stuff: body}), {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/ott/markers/${id}`);
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttStreamMarker>> {
    return this.http
      .get(`/ott/markers/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireOttStreamMarker>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttStreamMarker>> {
    return this.http
      .patch(`/ott/markers/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
